import { render, staticRenderFns } from "./HeaderMainComponent.vue?vue&type=template&id=8a746d50"
import script from "./HeaderMainComponent.vue?vue&type=script&lang=js"
export * from "./HeaderMainComponent.vue?vue&type=script&lang=js"
import style0 from "./HeaderMainComponent.vue?vue&type=style&index=0&id=8a746d50&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports